const LOCAL = localStorage.getItem('permissions');

const INITIAL = {
  sections: {
    search: true,
    people: true,
    organizations: true,
    franchise: true,
  },
  components: {
    addresses: {
      read: true,
      write: true,
    },
    contacts: {
      read: true,
      write: true,
    },
    issues: {
      read: true,
      write: true,
    },
    orgGroups: {
      read: true,
      write: true,
    },
    orgAndRoles: {
      read: true,
      write: true,
    },
    identifiers: {
      read: true,
      write: true,
    },
  },
};

export const permissions = LOCAL ? JSON.parse(LOCAL) : INITIAL;
